import React from 'react';
import { useSelector } from 'react-redux';
import { IUserStoreState, userSelector } from 'user-reducer/src/user-reducer';
import GoDeals from '../GoDeals/GoDeals';
import LastMinute from '../LastMinute/LastMinute';
import * as S from './NotificationLayout.styles';

const NotificationLayout = (props) => {
    const userDetails = useSelector(userSelector) as IUserStoreState;
    const isLoggedIn = !!userDetails?.isLoggedIn;
    const { bus } = props
    const { scheduleTxt, is_nitro, nitro_offer, isRedDeal, reddeal } = bus

    return (
        <S.NotificationSection>
            <S.LeftSection>
                {scheduleTxt ? <S.BusNotificationDiv>{scheduleTxt}</S.BusNotificationDiv> : <></>}
                {!isLoggedIn && isRedDeal && reddeal?.persuasion && Object.keys(reddeal.persuasion).length > 0 ? <GoDeals persuasion={reddeal.persuasion} /> : <></>}
                {is_nitro && nitro_offer && Object.keys(nitro_offer).length > 0 ? <LastMinute nitro_offer={nitro_offer} /> : <></>}
            </S.LeftSection>
            <S.RightSection>
            </S.RightSection>
        </S.NotificationSection>
    )
}

export default NotificationLayout;
